<template lang="pug">
.list-base-item(@click="$emit('click')")
  img.cover(:src="itemData.cover")
  .detail
    .title {{ itemData.title }}
    .describe {{ itemData.describe }}
    .info
      TagView(:tags="itemData.tags")
      .info-item(v-for="(info, infoIndex) in itemData.otherInfos" :key="infoIndex") {{ info }}
</template>

<script>
export default {
  name: "ListBaseItem",
  props: {
    itemData: Object,
  }
}
</script>

<style lang="scss" scoped>
.list-base-item{
  display: flex;
  padding: 12px 0;
  cursor: pointer;
  .cover{
    flex: 0 0 176px;
    @include size(176px, 132px);
    object-fit: cover;
  }
  .detail{
    padding-left: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title{
      font-weight: 700;
      font-size: 16px;
      color: #202948;
    }
    .describe{
      font-size: 14px;
      line-height: 18px;
      color: rgba(0, 0, 0, 0.39);
      @include textOverflow(3);
    }
    .info{
      display: flex;
      align-items: center;
      .info-item{
        font-size: 12px;
        color: #999999;
        & + .info-item{
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
